// Copyright (c) 2017 Deere & Company

const allowedColumnSeparatorKeys = ['1', '2'];

const columnSeparators = {
    1: ',',
    2: ';'
};

export const getColumnSeparator = key =>
    key && allowedColumnSeparatorKeys.includes(key) ? columnSeparators[key] : ',';



// WEBPACK FOOTER //
// ./src/shared/services/get-column-separator.js